import React from 'react';
import { Download } from 'lucide-react';

const phaseInfo = {
  1: { 
    name: 'Stabilize', 
    description: 'Building safety in your nervous system',
    workbookUrl: 'https://customer-assets.emergentagent.com/job_women-healing-hub/artifacts/hkb66zmo_sage_phase1_stabilize_workbook.pdf'
  },
  2: { 
    name: 'Understand', 
    description: 'Making sense of what happened',
    workbookUrl: 'https://customer-assets.emergentagent.com/job_women-healing-hub/artifacts/hvnbh943_sage_phase2_understand_workbook.pdf'
  },
  3: { 
    name: 'Reclaim', 
    description: 'Reconnecting with who you are',
    workbookUrl: 'https://customer-assets.emergentagent.com/job_women-healing-hub/artifacts/grby08by_sage_phase3_reclaim_workbook.pdf'
  },
  4: { 
    name: 'Renew', 
    description: 'Opening to what comes next',
    workbookUrl: 'https://customer-assets.emergentagent.com/job_women-healing-hub/artifacts/j8bjpdpk_sage_phase4_renew_workbook.pdf'
  },
};

export const PhaseCard = ({ phase = 1, animateIn }) => {
  const currentPhase = phaseInfo[phase] || phaseInfo[1];

  const handleDownload = () => {
    window.open(currentPhase.workbookUrl, '_blank');
  };

  return (
    <section 
      className={`mb-10 transition-all duration-700 ${animateIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
      style={{ transitionDelay: '0.3s' }}
    >
      <div 
        className="p-6 rounded-2xl relative overflow-hidden"
        style={{ 
          background: 'linear-gradient(135deg, rgba(138,158,143,0.1) 0%, rgba(201,168,76,0.05) 100%)',
          border: '1px solid rgba(138,158,143,0.2)',
        }}
      >
        {/* Phase indicator dots */}
        <div className="flex items-center gap-2 mb-4">
          {[1, 2, 3, 4].map((p) => (
            <div 
              key={p}
              className="w-2 h-2 rounded-full transition-all duration-300"
              style={{ 
                background: p === phase 
                  ? '#72826F' 
                  : p < phase 
                    ? 'rgba(138,158,143,0.5)' 
                    : '#EAE4DC',
                boxShadow: p === phase ? '0 0 10px rgba(138,158,143,0.5)' : 'none'
              }}
            />
          ))}
        </div>
        
        <div className="flex items-start justify-between gap-4">
          <div>
            <p 
              className="text-xs tracking-[0.15em] mb-1"
              style={{ 
                fontFamily: 'Jost, sans-serif',
                color: 'rgba(138,158,143,0.8)'
              }}
            >
              PHASE {phase}
            </p>
            <h3 
              className="text-xl mb-1"
              style={{ 
                fontFamily: 'Playfair Display, serif',
                color: '#72826F'
              }}
            >
              {currentPhase.name}
            </h3>
            <p 
              className="text-sm"
              style={{ 
                fontFamily: 'Jost, sans-serif',
                color: '#6B6878'
              }}
            >
              {currentPhase.description}
            </p>
          </div>
          
          {/* Download workbook button */}
          <button
            onClick={handleDownload}
            className="flex items-center gap-2 px-4 py-2 rounded-full transition-all duration-300 hover:scale-105"
            style={{ 
              background: 'rgba(138,158,143,0.15)',
              border: '1px solid rgba(138,158,143,0.3)',
            }}
            title={`Download Phase ${phase} Workbook`}
            data-testid="download-workbook"
          >
            <Download className="w-4 h-4" style={{ color: '#72826F' }} />
            <span 
              className="text-xs"
              style={{ 
                fontFamily: 'Jost, sans-serif',
                color: '#72826F'
              }}
            >
              Workbook
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export { phaseInfo };
